import { ChangeDetectorRef, Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Job } from 'server/shared/models/job';

export type InviteeAvailableJob = Pick<
  Job,
  '_id' | 'date' | 'department' | 'organisation' | 'shifts'
> & { isAvailable: boolean };

export type InviteeAvailableJobAction = 'cancel' | 'keep-open' | 'cancel-jobs';

export interface InviteeAvailableJobsDialogData {
  openJobs: InviteeAvailableJob[];
}

@Component({
  selector: 'app-available-jobs-dialog',
  templateUrl: './invitee-available-jobs-dialog.component.html',
  styleUrls: ['./invitee-available-jobs-dialog.component.scss'],
})
export class InviteeAvailableJobsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<InviteeAvailableJobsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InviteeAvailableJobsDialogData,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
  ) {
    setTimeout(() => {
      console.log('Constructor timeout - forcing change detection');
      this.ngZone.run(() => {
        this.cdr.detectChanges();
      });
    }, 0);
  }

  cancel(): void {
    this.closeDialog('cancel');
    this.dialogRef.close();
  }

  keepOpen(): void {
    this.closeDialog('keep-open');
  }

  cancelJobs(): void {
    this.closeDialog('cancel-jobs');
  }

  closeDialog(action: InviteeAvailableJobAction): void {
    this.ngZone.run(() => {
      this.dialogRef.close(action);
    });
  }
}
